export default "__VITE_ASSET__BWItvnUC__"